import React, { useEffect } from 'react'
import { Columns, Container, Element, Heading, Hero, Image, Section } from 'react-bulma-components'
import Layout from '../components/layout/layout'
import CheckStatusForm, {
  CheckStatusFormProps,
} from '../components/product-items/check-status-form'
import { useCheckSerialNumberStatusMutation } from '../queries'
// @ts-expect-error
import rockRiderLogo from '../assets/images/decathlon-rockrider-logo.png'
// @ts-expect-error
import bikeImg from '../assets/images/bike.jpg'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { useTranslations } from '../hooks/use-translations'
import { Translate } from '../utils/translations'

const HomePage: React.FC = () => {
  const { current: currentLanguage } = useTranslations()
  const mutation = useCheckSerialNumberStatusMutation()
  const navigate = useNavigate()

  const recallStatusRoute = `/${currentLanguage}/recall-status/${mutation.data?.serialNumber.complete}`

  useEffect(() => {
    if (!mutation.isSuccess) return
    if (!mutation.data) return
    if (!mutation.data.requestor) return
    if (!mutation.data.requestor.firstName) return
    if (!mutation.data.requestor.lastName) return
    const mutationStatus = mutation.data?.status
    if (mutationStatus === 'good' || mutationStatus === 'defective') {
      const { firstName, lastName } = mutation.data.requestor
      console.log(`${recallStatusRoute}?${createSearchParams({ firstName, lastName })}`)
      navigate(`${recallStatusRoute}?${createSearchParams({ firstName, lastName })}`)
    }
  }, [mutation.data])

  const [serialNumberValidation, setSerialNumberValidation] =
    React.useState<CheckStatusFormProps['serialNumberValidation']>()

  React.useEffect(() => {
    if (mutation.error?.code) setSerialNumberValidation('unknown')
    else
      setSerialNumberValidation(
        mutation.data?.status as CheckStatusFormProps['serialNumberValidation'],
      )
  }, [mutation.error?.code])

  mutation.error?.code === 404 ? 'unknown' : mutation.data?.status

  return (
    <Layout>
      <Image src={rockRiderLogo} style={{ maxWidth: 400, margin: 'auto' }} p={6} />
      <Section>
        <Container>
          <Heading size={1} textAlign="center">
            <Translate value="home.title" />
          </Heading>
          <Image src={bikeImg} style={{ maxWidth: 500, margin: 'auto' }} p={6} />
          <Columns centered>
            <Columns.Column size={10}>
              <Element renderAs="p" mt={5} textSize={4} textAlign="center">
                <Translate value="home.description" />
              </Element>
            </Columns.Column>
          </Columns>
        </Container>
      </Section>
      <Section mb={6}>
        <Container>
          <Heading size={3} mb={6} pb={3} textAlign="center">
            <Translate value="home.form.title" />
          </Heading>
          <CheckStatusForm
            onSubmit={mutation.mutate}
            serialNumberValidation={serialNumberValidation}
            onFormChange={() => setSerialNumberValidation(undefined)}
          />
          {/* {mutation.error?.code === 404 && <Element>Unknown doc</Element>}
          {mutation.data?.status === 'good' && <Element>Good item</Element>}
          {mutation.data?.status === 'defective' && <Element>Bad item</Element>} */}
        </Container>
      </Section>
    </Layout>
  )
}

export default HomePage
